module.exports = __webpack_public_path__ + "15056199b55f93364ee7e8f2c6645e34.png";